import { render } from "./BlogPage.vue?vue&type=template&id=73fc3f8f&ts=true"
import script from "./BlogPage.vue?vue&type=script&lang=ts"
export * from "./BlogPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__